type Category = {
  value: string;
  id: string;
}[];

export const categories: Category = [
  { value: 'AAC', id: 'AAC' },
  { value: 'A', id: 'A' },
  { value: 'B', id: 'B' },
  { value: 'C', id: 'C' },
  { value: 'D', id: 'D' },
  { value: 'E', id: 'E' },
];
